export const enum RouterName {
  Home = "/",
  // SongSheet = "/song-sheet",
  songStyle = "/song-style",
  SongSheetDetail = "/song-sheet-detail",
  // Singer = "/singer",
  songCycle = "/song-cycle",
  privateCustomization = "private-customization",
  entryPlatform = "/entryPlatform",
  SingerDetail = "/singer-detail",
  Personal = "/personal",
  Setting = "/setting",
  PersonalData = "/personal-data",
  memberCenter = "/member-center",
  SignIn = "/sign-in",
  SignUp = "/sign-up",
  Search = "/search",
  Lyric = "/lyric",
  Error = "/404",
  SignOut = "0",
  ForgotPassword="/FPassword",
  loginByemail="/loginByemail",
  PayRecord = "/pay-record",
  DownloadRecord = "/download-record",
  MyCollection = "/my-collection",
  Playlists = "/playlists",
}
